<div *ngIf="pwdExpiring" class="pwd-exp-message">
  <div id="business-managed-alert" class="businessManagedAlert-margin-bottom">Your password is expiring soon. Please use the change password feature to update your login information.
  </div>
</div>
<div >
  <div>
  <div *ngIf="businessManagedAlert != undefined && businessManagedAlert != ''"
  class="no-order-access-message alertMsg">
  <div id="business-managed-alert" [innerHTML]="businessManagedAlert | sanitizeHtml"
    class="businessManagedAlert-margin-bottom">
  </div>
</div>
</div>
</div>
<div class="slideshow-container" *ngIf="websiteName =='Parmed'">
  <div class="cmsSlides fades" *ngFor="let slide of carousel?.media; let i = index">
    <img id="carousel-img-{{i+1}}" (click)="onCarouselClick(slide)" src="{{slide.mediaUrl}}" style="width:100%">
  </div>
</div>
<div style="text-align:center; margin-top: -54px" *ngIf="websiteName =='Parmed'">
  <span class="cmsDots" id="carousel-dot-{{i+1}}"
    *ngFor="let slide of carousel?.media; let i = index" (click)="cmsCurrentSlide(i)"></span>
</div>
<br />

<div  class="cta-image-container" *ngIf="websiteName =='Parmed'">
  <div class="cta-inner-container">
    <mat-card *ngFor="let cta of contentArr; let i = index" class="cta-box item-card-container"
      [ngClass]="{'middle-box': i%2}">
      <img mat-card-image (click)="navigateToTargetLink(cta?.contentStructureJson)"
        src="{{cta?.contentStructureJson.mediaUrl}}" class="cta-img" />
      <mat-card-content>
        <h2 id="cta-header-{{i+1}}" class="cta-header">
          {{cta?.contentStructureJson.title}}
        </h2>
        <p id="cta-caption-{{i+1}}" [innerHTML]="cta?.contentStructureJson.description"></p>
      </mat-card-content>
      <mat-card-actions>
        <button (click)="ctaClick(i, cta?.contentStructureJson);" id="cta-button-{{i+1}}" color="accent"
          mat-raised-button>{{cta?.contentStructureJson.Button}}</button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
  
  <div  *ngIf=" websiteName == 'Major'" [ngClass]="{'majorPadding': isMobileDevice()}" class="main-major-container">
    <div  [ngClass]="{'majortop-container': isDesktopDevice() , 'majortop-container-mobile' : isMobileDevice()}" >
      <div  *ngIf="homePageResponseHeader?.length>0">
          <div class="static-content"   style="width: 100% !important;">  
              <h2  class="title-header" [innerHTML]="homePageResponseHeader?.[0].title"></h2>
              <p  class="top-desc" [innerHTML]="homePageResponseHeader?.[0].description"></p> <br>
              <button class="learnMorebtn"(click)="navigateUrl(homePageResponseHeader?.[0]);"
              >{{homePageResponseHeader?.[0].Button}}
            </button>
          </div>
        </div>
      <div class="cta-majorimage-container">
        <div class="cta-inner-container-major" >
          <mat-card *ngFor="let cta of homePageResponseHeader | slice:1; let i = index" class="cta-major-box">
            <img (click)="navigateUrl(cta)" src="{{cta.mediaUrl}}" class="mat-card-img"/><br>
            <mat-card-content class="mat-card-content-major">
              <h2  class="cta-title" >
                {{cta?.title}}
              </h2>  
              <p [ngClass]="{'consumer-content':isMobileDevice(),'desc-padding' :isDesktopDevice()}" style="margin-bottom: 60px !important;"   [innerHTML]="cta.description"></p>
              <mat-card-actions>
              <button class= "cta-btn" (click)="navigateUrl(cta);" color="accent"  
                mat-raised-button> {{cta?.Button}}
                <img src="../../../../assets/images/Major/Arrow_right_btn_icon.png" />
              </button>
            </mat-card-actions>
             </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
    <div  *ngIf="homePageResponseCta?.length>0">
      <div  class="bottom-static-content"  style="width: 100% !important;">  
          <h2 [ngClass]="{'title-btm-header-mobile':isMobileDevice(),'title-header keepHeader':isDesktopDevice()}" [innerHTML]="homePageResponseCta[0]?.title"></h2>
          <p  class="static-desc" [innerHTML]="homePageResponseCta[0]?.description"></p> 
      </div>
    </div>
    <div class="cta-majorbtm-container">
      <div class="cta-inner-btm-container">
        <div *ngFor="let cta of homePageResponseCta | slice:1; let i = index" class="cta-major-btm">
          <img  [ngClass]="{'img-placeholder' : !cta.mediaUrl , 'cta-btm-img': cta.mediaUrl}"  (click)="navigateToTargetLink(cta)" src="{{cta.mediaUrl}}" >
          <br>
          <mat-card-content class="major-btm-content">
            <h2  class="cta-btm-title" >
              {{cta?.title}}
            </h2>  
            <p style="font-size: 14px !important;" [innerHTML]="cta.description"></p>
            <button class="ndc-btn" (click)="ctaClick(i, cta);" color="accent"
              mat-raised-button>{{cta?.Button}}
              <img src="../../../../assets/images/Major/Arrow_right_btn_icon.png" />
            </button><br>
           </mat-card-content>
          </div>
      </div>
    </div>
    <hr class="hr-tag" >
    <div  *ngIf="staticBottomContent?.length>0">
      <div  class="bottom-static-content"  style="width: 100% !important;">  
          <h2 class="title-header-btn"  style="margin-top: 40px !important;" [innerHTML]="staticBottomContent[0].title"></h2>
          <p  [innerHTML]="staticBottomContent[0]?.description"></p> 
      </div>
    </div>
    <div  *ngIf="staticBottomContent?.length>0">
      <div class="btm-content">  
          <h2 class="footer-content-header bottom-static-content" [innerHTML]="staticBottomContent[1]?.title"></h2>
          <p class="footer-desc bottom-static-content" [innerHTML]="staticBottomContent[1]?.description"></p> <br>
          <div (click)="scrollProduct('slideC')">
          <button class="btm-btn" (click)="downloadFullProductCatalog();"
    color="accent" mat-raised-button >{{staticBottomContent[1]?.Button}}
            <img src="/assets/images/mobile/Major/Download_btn_icon.png" class="download-icon" alt="" title="" />
          </button>
          </div>
            <br>
      </div>
    </div>
    <div *ngIf="isDownloadProduct" class="margin" id="slideC"
    [ngClass]="{'downloadproductMobile': isMobileDevice() && websiteName == 'Major'  , 'downloadproduct': !isMobileDevice()}">
    <button mat-icon-button class="close-button" (click)="isDownloadProduct=!isDownloadProduct">
      <mat-icon class="close-icon">close</mat-icon>
    </button>
    <p class="b-align" style="color: #534848;">Let us know who you are so we can better serve you! </p>
    <!-- <br> -->
    <!-- <p class="content-text" style="margin-top: 10px;"> Understanding our site visitors allows us to personalize their
      experience and product offerings.</p> -->
   <b class="content-download" style="margin-top: 5px;">Select the option that best describes you to download the
      product catalog. </b>
  
    <div class="button-group">
      <button color="accent" (click)="onProductChange($event)" [ngClass]="{'activebtn':selectedRole=='Current customer'}"
        value="Current customer" class="button">Current Customer
      </button>
      <button color="accent" (click)="onProductChange($event)" [ngClass]="{'activebtn':selectedRole=='Previous customer'}"
        value="Previous customer" class="button">Previous Customer
      </button>
      <button color="accent" (click)="onProductChange($event)"
        [ngClass]="{'activebtn':selectedRole=='Potential customer'}" value="Potential customer" class="button">Potential
        Customer
      </button>
      <button color="accent" (click)="onProductChange($event)"
        [ngClass]="{'activebtn':selectedRole=='Supplier Manufacturer'}" value="Supplier Manufacturer"
        class="button">Supplier/Manufacturer
      </button>
      <button color="accent" (click)="onProductChange($event)" [ngClass]="{'activebtn':selectedRole=='Consumer'}"
        value="Consumer" class="button">Consumer
      </button>
      <button color="accent" (click)="onProductChange($event)"
        [ngClass]="{'activebtn':selectedRole=='Major Rugby Employee'}" value="Major Rugby Employee"
        class="button">Major Rugby Employee
      </button>
      <button color="accent" (click)="onProductChange($event)" [ngClass]="{'activebtn':selectedRole=='Other'}"
        value="Other" class="button">Other
      </button><br>
  
    </div>
    <div class="row">
  
      <div class="col-lg-3 mt-20 " [ngClass]="{'btn-download' : isDesktopDevice(),'download-mobile':isMobileDevice()}">
        <button type="submit" mat-raised-button color="accent" id="btn-search" class="download-full-product buttonAlign"
          (click)="navigateToTargetLink(staticBottomContent?.[1])" [disabled]="!selectedRole"
          style="width: 100% !important;padding:2px !important;margin-top: 0px !important; margin-left: 0px !important;"
          matTooltip="Download Full Catalog" matTooltipClass="product-tool-tip" matTooltipPosition="right" color="accent"
          mat-raised-button>{{staticBottomContent[1]?.Button}}
          <!-- <span class="glyphicon glyphicon-download-alt black"></span> -->
          <img src="/assets/images/mobile/Major/Download_btn_icon.png" class="download-icon" />
        </button>
      </div>
      <div class="col-lg-9 mt-20 ">
        <img src="../../../../assets/images/Major/dark-gray circle.png" /><span class="spanAlign content ">
         Please select an option above to download the product catalog</span>
  
      </div>
    </div>
  
  </div>
    </div>